<template>
  <div
    id="searchableSelectWithButtonInOptions"
    v-click-outside="onClickOutsideHideOptions"
    class="dropdown__with__button"
    @click="onClickShowOptions">
    <div
      :class="[
        'dropdown__with__button__container',
        { 'dropdown__with__button__container--focus': isOptionsOpen },
      ]">
      <input
        id="searchableSelectWithButtonInOptions-input"
        type="text"
        placeholder="Search saved filters"
        class="dropdown__with__button__container__input"
        :value="query"
        @keyup="filterFunction($event)" />
      <span
        :class="[
          'mi-20px',
          isOptionsOpen ? 'mi-chevron-up' : 'mi-chevron-down',
        ]"></span>
    </div>
    <div
      v-if="isOptionsOpen"
      class="dropdown__with__button__options__container">
      <div
        v-for="(item, index) in computedOptions"
        :key="`${index}-${item.filter_title}`"
        class="dropdown__with__button__options"
        @click.stop="onSelect(item)">
        <div class="dropdown__with__button__options__option">
          <p
            v-tooltip="item.filter_title"
            class="dropdown__with__button__options__option__content">
            {{ item.filter_title }}
          </p>
          <span
            class="dropdown__with__button__options__option__icon mi-20px mi-trash"
            @click.stop="onDelete(item)"></span>
        </div>
      </div>
    </div>
    <template v-if="isOptionsOpen && computedOptions.length === 0">
      <div class="dropdown__with__button__options">No saved filters found</div>
    </template>
  </div>
</template>

<script>
// Directives
import ClickOutside from "vue-click-outside";

export default {
  name: "DropdownWithButton",
  directives: {
    ClickOutside,
  },
  props: {
    options: {
      type: Array,
      default() {
        return [];
      },
    },
    selectedFilter: {
      type: [Object, null],
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      query: this.selectedFilter.filter_title,
      isOptionsOpen: false,
    };
  },
  computed: {
    computedOptions() {
      return this.query
        ? this.options.filter((option) => {
            return option.value
              ?.toString()
              .toLowerCase()
              .match(this.query.toLowerCase());
          })
        : this.options;
    },
  },
  watch: {
    selectedFilter() {
      this.query = this.selectedFilter.filter_title;
    },
  },
  methods: {
    onClickShowOptions() {
      this.isOptionsOpen = true;
      this.query = "";
    },
    onClickOutsideHideOptions() {
      this.isOptionsOpen = false;
      this.query = this.selectedFilter.filter_title;
    },
    filterFunction(event) {
      this.query = event.target.value;
      this.isOptionsOpen = true;
    },
    onDelete(deleteSelectedItem) {
      this.$emit("onChange", { value: deleteSelectedItem });
      this.$emit("onDelete");
    },
    onSelect(selectedItem) {
      this.$emit("onChange", { value: selectedItem });
      this.onClickOutsideHideOptions();
    },
  },
};
</script>

<style lang="scss" scoped>
.dropdown__with__button {
  border: 1px solid var(--Gray-300);
  border-radius: 4px;
  min-width: 352px;
  position: absolute;
  z-index: 1;

  &__container {
    border-radius: 4px;
    padding: 16px;

    &:hover {
      border: 0.1px solid var(--Gray-600);
    }

    &--focus {
      border: 0.1px solid var(--Blue-400) !important;
      border-bottom: unset !important;
      box-shadow: 0 0 0 3px var(--Blue-50-Light);
    }

    &__input {
      box-sizing: border-box;
      background: transparent;
      border: none;
      font-size: 16px;
      color: var(--Blue-900-Darkest);
      width: 296px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      &:focus {
        outline: 3px solid transparent;
      }
    }
  }

  &__options {
    background-color: var(--Gray-50);
    color: var(--Blue-900-Darkest);
    display: block;
    padding: 12px 16px;
    text-decoration: none;

    &:hover {
      background-color: #5897fb;
      color: var(--Gray-100);
    }

    &__container {
      max-height: 240px;
      overflow: auto;
    }

    &__option {
      display: flex;
      justify-content: space-between;
      align-items: center;
      cursor: pointer;

      &__content {
        max-width: 268px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      &__icon {
        cursor: pointer;
      }
    }
  }
}
</style>
